import Cookie from 'js-cookie';
import { generateHashCode } from '@/shared/utils/hash-code';

const generateCookie = (opts = {}) => {
  const hash = generateHashCode(`${opts.id.toString()}-${opts.time.valueOf().toString()}`);
  const cookie = `${opts.id}-${hash}`;
  const name = opts.name;

  if (name) {
    Cookie.set(name, cookie);
  }
};

export { generateCookie };
